export const getQueryStringValueFromURL = (queryStringName: string): string => {
  return new URLSearchParams(location.search).get(queryStringName) || '';
};

export const getQueryParams = () => {
  return Object.fromEntries(new URLSearchParams(location.search));
};

export const createQueryStringFromObject = (queryObject: any) => {
  return new URLSearchParams(queryObject).toString();
};

export const getSidFromUrl = () => {
  if (typeof window !== 'undefined') {
    const { search } = window.location;
    const params = new URLSearchParams(search);
    return params.get('sid') || params.get('appsid');
  }

  return '';
};

export const setPageTitle = (page) => {
  document.title = `Anghami Creators - ${page}`;
};

/**
 * Schemes considered safe to place in an anchor `href`.
 * Anything else (notably `javascript:`, `data:`, `vbscript:`) is rejected to
 * prevent XSS when interpolating untrusted values (e.g. API-provided links)
 * into anchor tags.
 */
const SAFE_URL_SCHEMES = ['http', 'https', 'mailto', 'tel'];

// Control characters (C0 0-31, DEL/C1 127-159) that browsers strip from URLs.
// They must be removed before checking the scheme so a payload can't smuggle
// one past the check, e.g. "java\tscript:alert(1)". Built via fromCharCode to
// avoid embedding raw control characters in source.
const IGNORED_URL_CHARS = new RegExp(
  '[' +
    String.fromCharCode(0) +
    '-' +
    String.fromCharCode(31) +
    String.fromCharCode(127) +
    '-' +
    String.fromCharCode(159) +
    ']',
  'g'
);

/**
 * Returns the URL only when it is safe to use in an `href`, otherwise
 * `undefined` (which makes React drop the attribute, so the link won't
 * navigate). URLs without an explicit scheme (relative paths, anchors) are
 * left untouched.
 */
export const getSafeUrl = (url?: string | null): string | undefined => {
  if (!url) return undefined;
  const trimmed = url.trim();
  if (!trimmed) return undefined;
  const scheme = trimmed.replace(IGNORED_URL_CHARS, '').match(/^([a-z][a-z0-9+.-]*):/i);
  if (scheme && !SAFE_URL_SCHEMES.includes(scheme[1].toLowerCase())) {
    return undefined;
  }
  return trimmed;
};

export const decodeQueryParams = (encodedString: string) =>
  decodeURIComponent(escape(window.atob(encodedString)));

export const encodeQueryParams = (decodedString: string) =>
  btoa(unescape(encodeURIComponent(decodedString)));

export const getEncodedQueryParam = (formQueryParam: string) => {
  // encoded query param is a stringified json object base64 encoded
  return formQueryParam ? JSON.parse(decodeQueryParams(formQueryParam)) : {};
};
